<template>
  <el-dialog
    id="popup_dialog"
    :title="titlu"
    :visible.sync="showPopup"
    class="my-dialog-class custom-width"

  >
    <div class="container">
      <el-form
        label-position="top"
        :inline="false"
        :rules="rules"
        label-width="100%"
        :model="selectedObject"
        ref="my-form"
        @submit.prevent="save"
        v-loading="loadingVisible"
      >
        <el-row :gutter="15">
          <el-col :md="8">
            <el-form-item label="Nume" prop="Nume">
              <el-input class="full-width" v-model="selectedObject.Nume" />
            </el-form-item>
          </el-col>          
          <el-col :md="8">
            <el-form-item label="Email" prop="Email">
              <el-input class="full-width" v-model="selectedObject.Email" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Cui" prop="Cui">
              <el-input class="full-width" v-model="selectedObject.Cui" />
            </el-form-item>
          </el-col>
          <!-- <el-col :md="8">
            <el-form-item label="Nr. Reg. Com." prop="RegCom">
              <el-input class="full-width" v-model="selectedObject.RegCom" />
            </el-form-item>
          </el-col> -->
          <el-col :md="8">
            <el-form-item label="Adresa" prop="Adresa">
              <el-input class="full-width" v-model="selectedObject.Adresa" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Observatii" prop="Observatii">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="Observatii"
                  v-model="selectedObject.Observatii">
                  </el-input> 
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Firme_flote_dialog",
  extends: BasePage,
  data() {
    let validateEmail = async (rule, value, callback) => {
      if (String(value).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        callback();
      } else {
        callback(new Error("Email-ul introdus nu este unul valid"))
      }
    }

    let validateNumeric = async (rule, value, callback) => {
      if (value === undefined || value.length < 0 || value == null || this.selectedObject.Cui.length <= 0) return callback('Campul este obligatoriu')
      this.selectedObject.Cui = value.split("").filter(a => /^\d+$/.test(a)).join("");

    } 
    return {
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        Nume: "",
        Email: "",
        Cui: "",
        RegCom: "",
        Adresa: "",
        Observatii: "",
      },
      Info: {},
      rules: {
        Nume:  [{ required: true, message: "Campul este obligatoriu" }],
        Email: [{ required: true, validator: validateEmail }],
        Cui:   [{ required: true, validator: validateNumeric }],
      },
    };
  },
  methods: {
    
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga flota";
        this.selectedObject = {};
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza flota";
        var result = await this.post("admin/flote/get_info_item_dialog_firme", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },
    async get_info() {
      // var response = await this.post("admin/flote/get_info_for_dialog_firme");
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          let raspuns = await this.post("admin/flote/save_firme", {
            mode: this.mode,
            object: this.selectedObject,
          });
          if(raspuns.Eroare == 1){
            let mesaj = 'A aparut o problema - modificarile nu au fost salvate!';
            if(raspuns.RaspunsEroare.length > 0) mesaj += ' ' + raspuns.RaspunsEroare;
            this.$notify({
              title: 'Eroare',
              message: mesaj,
              type: 'error',
            });
          } else {
            this.showPopup = false;
            this.$emit("save");
            this.selectedObject = {};
            this.$notify({
              title: 'Success',
              message: 'Modificarile au fost salvate!',
              type: 'success',
            });
          }
         
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog{
      min-width: 90vw !important;
    }
  }
}
</style>